import ApiContext from "src/provider/API/call-service";
import { useContext } from "react";
import { useQuery } from "react-query";

export const useGetCbpDocs = () => {
  const { API } = useContext(ApiContext);
  const fetchCbpDocs = async () => {
    const response = await API.getCbpDocs();
    return response?.data;
  };

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["get-cbpDocs"],
    queryFn: fetchCbpDocs,
    cacheTime: 24 * 60 * 60 * 1000 , 
  });

  return { data, isLoading, isError, error };
};
